export const AI_FIRST_CODING_EXERCISE = 'AiFirstCodingExercise';
export const EXPORTED_EXERCISES = [AI_FIRST_CODING_EXERCISE];